<template>
  <div class="fillcontain">
    <head-top></head-top>
    <div class="select_container">
      <el-button type="primary" style="float: right;" @click="addFood()">新增课程</el-button>
    </div>
    <div class="table_container">
      <el-table
        :data="tableData"
        style="width: 100%">
        <el-table-column
          label="序号"
          type="index" width="70">
        </el-table-column>
        <el-table-column
          label="课程名称"
          prop="courseName">
        </el-table-column>
        <el-table-column
          label="时长"
          prop="timeLength">
        </el-table-column>
        <el-table-column
          label="作品赏析"
          prop="worksNum">
        </el-table-column>
        <el-table-column
          :formatter="formatDate"
          label="上传时间"
          prop="updateTime">
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="200">
          <template slot-scope="scope">
            <el-button size="mini" v-if="scope.row.top!='0'" type="text" @click="getnoTop(scope.$index, scope.row)">取消置顶</el-button>
            <el-button size="mini" v-if="scope.row.top=='0'" type="text" @click="getTop(scope.$index, scope.row)">置顶</el-button>
            <el-button size="mini" type="text" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" type="text" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="Pagination">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="20"
          layout="total, prev, pager, next"
          :total="total">
        </el-pagination>
      </div>


    </div>
  </div>
</template>

<script>
  import headTop from '../components/headTop'
  import { getCurriculum,getDelcourse,chaindata,getNoTop } from "../api/api"
  export default {
    data () {
      return {
        value: '',
        options:[],
        filters: {
          name: ''
        },
        selectTable: {},
        tableData: [],
        currentRow: null,
        limit: 20,
        total: 0,
        currentPage: 1,
        dialogVisible:false,
        value1: '',
      }
    },
    components: {
      headTop,
    },
    methods:{
      //时间戳转换
      formatDate:function (value){
        var dateee = new Date(value.updateTime).toJSON();
        return new Date(+new Date(dateee)+8*3600*1000).toISOString().replace(/T/g,' ').replace(/\.[\d]{3}Z/,'')
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getCurriculum()
      },
      getCurriculum(){
        let params={
          category:4,
          pageNum:this.currentPage,
          pageSize:this.limit,
        };
        //获取课程管理列表
        getCurriculum(params).then(res=>{
          this.total = res.total
          this.tableData = res.pageInfo
          // console.log(res)
        }).catch(error=>{
          console.log(error);
        })

        //获取课程分类列表

      },
      handleEdit(index, row) {
        //编辑
        this.$router.push({
          path: 'modTrialCourse',
          query:{
            id:row.courseId,
            category:row.category
          }
        });
      },
      addFood(){
        //新增
        this.$router.push({ path: 'newTrialCourse'});
      },
      handleDelete(index, row){
        //删除
        this.$confirm('确认删除该记录吗？', '提示', {
          // type: 'warning'
        }).then(() => {
          let params={
            courseId:row.courseId,
            operationId:JSON.parse(sessionStorage.getItem('user')).id,
            category:row.category
          };
          getDelcourse(params).then(res=>{
            if (res.state == true) {
              this.$message({
                type: 'success',
                message: res.msg
              });
              this.tableData.splice(index, 1);
            }else{
              throw new Error(res.message)
            }
          }).catch(error=>{
            this.$message({
              type: 'error',
              message: res.msg
            });
          })
        })
      },
      getTop(index, row){
        //  置顶
        let params = ({
          courseId:row.courseId,
          operationId:JSON.parse(sessionStorage.getItem('user')).id
        })
        chaindata(params).then(res=>{
          if (typeof (res) == 'number') {
            this.$message({
              type: 'success',
              message: '置顶成功'
            });
            this.getCurriculum()
            let timer = setInterval(()=>{
              row.top = res;
            },500)
          }else{
            throw new Error(res.message)
          }
        }).catch(error=> {
          this.$message({
            type: 'error',
            message: '置顶失败'
          });
        })
      },
      getnoTop(index, row){
        //  取消置顶
        let params = ({
          courseId:row.courseId,
          top:0,
          operationId:JSON.parse(sessionStorage.getItem('user')).id,
        })
        getNoTop(params).then(res=>{
          if (res.state = true) {
            this.$message({
              type: 'success',
              message: res.msg
            });
            row.top = 0
            this.getCurriculum()
          }else{
            throw new Error(res.message)
          }
        }).catch(error=> {
          this.$message({
            type: 'error',
            message: '取消置顶失败'
          });
        })
      }
    },
    activated(){
      this.getCurriculum()
    },

  }
</script>

<style lang="less">
  @import '../style/mixin';
</style>



// WEBPACK FOOTER //
// src/page/trialcourse.vue